import Booking from "../booking";
import BookingList from "../pages/booking-list";
import ArtistList from "../pages/artists";
import BookingCalendar from "../pages/calendar";
import LoggedUserTasks from "../pages/tasks";
import TaskList from "../pages/task-list";
import BookingRequests from "../pages/requests";
import BookingTemplates from "../pages/template-list";
import BookingPromoters from "../pages/promoters";
//import BookingReports from "../pages/booking-reports";
import BookingReports from "../components/reports/booking-reports.vue";
import BookingVenues from "../pages/venues";
import BookingPlugins from "../components/plugins/plugins";
import BookingTours from "../pages/tours";
import { either } from "ramda";
import { bookingArtistListLDTRoutes, bookingPromoterListLDTRoutes, bookingTemplateListLDTRoutes } from "./routes";

import DTable from "../../../components/main/pro-agency-data-transfer/pro-agency-data-transfer";

import {
  bookingTasks,
  bookingRequestsRouterName,
  bookingRequestsWizardRouterName,
  bookingPromotersRouterName
} from "../../../router/functions";
import {
  createRouteName,
  childOf,
  childOfOrEqual
} from "../../../router/functions";
import {
  getDetailsTabRoutes,
  getDetailsTabRouteObjects,
  getSelectableResult
} from "../../../utility/route";

// import { getBookingListCalendarDateRoute, getBookingCalRoute, getBookingCalCalendarDateRoute, getBookingCalCalendarDateTabRoute, getBookingListRoute, getBookingListCalendarDateTabRoute } from './index';

// TODO: Because of unknown reason the string export is undefined in other vuejs Components

export const bookingListRoute = "booking_list";
export const bookingListCalendarDateRoute = createRouteName(
  bookingListRoute,
  "calendar_date_id"
);
export const bookingListCalendarDateTabRoute = createRouteName(
  bookingListCalendarDateRoute,
  "tab"
);

export const bookingLDTRoutes = getDetailsTabRoutes(
  "booking_list",
  "calendar_date_id"
);

export const bookingCalRoute = "booking_calendar";
export const bookingCalCalendarDateRoute = createRouteName(
  bookingCalRoute,
  "calendar_date_id"
);
export const bookingCalCalendarDateTabRoute = createRouteName(
  bookingCalCalendarDateRoute,
  "tab"
);

export const artistListRoute = "artists";
export const artistDetailsRoute = createRouteName(
  bookingArtistListLDTRoutes,
  "artist_details"
);
export const artistDetailsTabRoute = createRouteName(artistDetailsRoute, "tab");

export const bookingPromoterListRoute = "booking_promoter";
export const bookingPromoterDetailsRoute = createRouteName(
  bookingPromoterListRoute,
  "promoter_id"
);
export const bookingPromoterDetailsTabRoute = createRouteName(
  bookingPromoterDetailsRoute,
  "tab"
);
export const bookingPromoterRoutes = getDetailsTabRoutes(
  "promoters",
  "promoter_id"
);

export const bookingVenueRoutes = getDetailsTabRoutes("venues", "venue_id");

// export const bookingTemplateListRoute = "booking_templates";
// export const bookingTemplateDetailsRoute = createRouteName(
//   bookingTemplateListRoute,
//   "template_details"
// );
// export const bookingTemplateDetailsTabRoute = createRouteName(
//   bookingTemplateDetailsRoute,
//   "tab"
// );

export const bookingReportsRoute = "booking_reports";

export const bookingPluginsRoute = "booking_plugins";

export const bookingToursRoute = "tours";
// console.log(getDetailsTabRoutes);

export const SelectResults = {
  SELECT: "SELECT",
  SELECT_AUTO: "SELECT_AUTO",
  IGNORE: "IGNORE",
  CLOSE: "CLOSE"
};

// If this function matches the calendar Details - sidewindow cane be opened
export const calendarDateSelectable = (to, from) => {
  let selectResult = SelectResults.IGNORE;

  if (
    to &&
    to.name &&
    either(
      childOfOrEqual(bookingListCalendarDateRoute),
      childOfOrEqual(bookingCalCalendarDateRoute)
    )(to.name)
  ) {
    if (from && from.params.calendar_date_id == to.params.calendar_date_id) {
      selectResult = SelectResults.IGNORE;
    } else if (!from) {
      selectResult = SelectResults.SELECT_AUTO;
    } else if (
      from &&
      from.name &&
      either(childOfOrEqual(bookingListRoute), childOfOrEqual(bookingCalRoute))(
        from.name
      )
    ) {
      selectResult = SelectResults.SELECT;
    }
  } else if (
    to &&
    to.name &&
    [bookingListRoute, bookingCalRoute].includes(to.name) &&
    from &&
    from.name &&
    either(
      childOf(bookingListCalendarDateRoute),
      childOf(bookingCalCalendarDateRoute)
    )(from.name)
  ) {
    selectResult = SelectResults.CLOSE;
  }

  const calendarDateId = to && to.params && to.params.calendar_date_id;

  if (
    !(parseInt(calendarDateId, 10) > -1) &&
    selectResult !== SelectResults.CLOSE
  ) {
    selectResult = SelectResults.IGNORE;
  }

  return {
    selectResult,
    calendarDateId
  };
};

export const artistDetailsSelectable = (to, from) => {
  let selectResult = SelectResults.IGNORE;
  // console.log(to, from);

  if (
    to &&
    to.name === bookingArtistListLDTRoutes.names.list &&
    from &&
    childOfOrEqual(bookingArtistListLDTRoutes.names.details)(from.name)
  ) {
    selectResult = SelectResults.CLOSE;
  } else if (
    childOfOrEqual(bookingArtistListLDTRoutes.names.details)(to.name) &&
    !from
  ) {
    selectResult = SelectResults.SELECT_AUTO;
  } else if (
    childOfOrEqual(bookingArtistListLDTRoutes.names.details)(to.name) &&
    from &&
    childOfOrEqual(bookingArtistListLDTRoutes.names.details)(from.name) &&
    to.params.artist_id != from.params.artist_id
  ) {
    selectResult = SelectResults.SELECT;
  } else if (
    childOfOrEqual(bookingArtistListLDTRoutes.names.details)(to.name) &&
    from &&
    from.name == bookingArtistListLDTRoutes.names.list
  ) {
    selectResult = SelectResults.SELECT;
  } else if (!from || to.params.artist_id == from.params.artist_id) {
    selectResult = SelectResults.IGNORE;
  }

  const artistId = to && to.params && to.params.artist_id;

  return {
    selectResult,
    artistId: artistId
  };
};

export const promoterDetailsSelectable = (to, from) => {
  let selectResult = SelectResults.IGNORE;
  // console.log(to, from);

  if (
    to &&
    to.name === bookingPromoterListRoute &&
    from &&
    childOfOrEqual(bookingPromoterDetailsRoute)(from.name)
  ) {
    selectResult = SelectResults.CLOSE;
  } else if (childOfOrEqual(bookingPromoterDetailsRoute)(to.name) && !from) {
    selectResult = SelectResults.SELECT_AUTO;
  } else if (
    childOfOrEqual(bookingPromoterDetailsRoute)(to.name) &&
    from &&
    childOfOrEqual(bookingPromoterDetailsRoute)(from.name) &&
    to.params.promoter_id != from.params.promoter_id
  ) {
    selectResult = SelectResults.SELECT;
  } else if (
    childOfOrEqual(bookingPromoterDetailsRoute)(to.name) &&
    from &&
    from.name == bookingPromoterListRoute
  ) {
    selectResult = SelectResults.SELECT;
  } else if (!from || to.params.promoter_id == from.params.promoter_id) {
    selectResult = SelectResults.IGNORE;
  }

  const promoterId = to && to.params && to.params.promoter_id;

  return {
    selectResult,
    promoterId
  };
};

export const getVenueDetailsSelectable = getSelectableResult(
  bookingVenueRoutes
);

export default [
  {
    path: "/main/booking",
    name: "booking",
    component: Booking,
    redirect: "main/booking/booking_list",
    children: [
      {
        name: bookingListRoute,
        path: "booking_list",
        component: BookingList
      },
      {
        name: bookingListCalendarDateRoute,
        path: "booking_list/:calendar_date_id",
        component: BookingList
      },
      {
        name: bookingListCalendarDateTabRoute,
        path: "booking_list/:calendar_date_id/:tab",
        component: BookingList
      },
      {
        name: bookingCalRoute,
        path: "calendar",
        component: BookingCalendar
      },
      {
        name: bookingCalCalendarDateRoute,
        path: "calendar/:calendar_date_id",
        component: BookingList
      },
      {
        name: bookingCalCalendarDateTabRoute,
        path: "calendar/:calendar_date_id/:tab",
        component: BookingList
      },
      {
        name: bookingTasks,
        path: "tasks",
        // component: LoggedUserTasks
        component: TaskList
      },
      {
        name: bookingRequestsRouterName,
        path: "requests",
        component: BookingRequests
      },
      {
        name: bookingRequestsWizardRouterName,
        path: "requests/:calendar_date_id",
        component: BookingRequests
      },
      // {
      //   name: bookingTemplateListRoute,
      //   path: "templates",
      //   component: BookingTemplates
      // },
      // {
      //   name: bookingTemplateDetailsRoute,
      //   path: "templates/:booking_template_id",
      //   component: BookingTemplates
      // },
      // {
      //   name: bookingTemplateDetailsTabRoute,
      //   path: "templates/:booking_template_id/:tab",
      //   component: BookingTemplates
      // },
      // {
      //   name: artistListRoute,
      //   path: "artists",
      //   component: ArtistList
      // },
      // {
      //   name: artistDetailsRoute,
      //   path: "artists/:artist_id",
      //   component: ArtistList
      // },
      // {
      //   name: artistDetailsTabRoute,
      //   path: "artists/:artist_id/:tab",
      //   component: ArtistList
      // },
      // {
      //   name: bookingPromoterListRoute,
      //   path: "promoters",
      //   component: BookingPromoters
      // },
      // {
      //   name: bookingPromoterDetailsTabRoute,
      //   path: "promoters/:promoter_id/:tab",
      //   component: BookingPromoters
      // },
      {
        name: bookingReportsRoute,
        path: "reports",
        component: BookingReports
      },
      // {
      //   name: bookingToursRoute,
      //   path: 'tours',
      //   component: BookingTours
      // },
      {
        name: bookingPluginsRoute,
        path: "plugins",
        component: BookingPlugins
      },
      ...getDetailsTabRouteObjects(bookingVenueRoutes, BookingVenues),
      ...getDetailsTabRouteObjects(bookingArtistListLDTRoutes, ArtistList),
      ...getDetailsTabRouteObjects(bookingPromoterListLDTRoutes, BookingPromoters),
      ...getDetailsTabRouteObjects(bookingTemplateListLDTRoutes, BookingTemplates),
    ]
  }
];
